import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 23H4C2.89543 23 2 22.1046 2 21V3C2 1.89543 2.89543 1 4 1H20C21.1046 1 22 1.89543 22 3V21C22 22.1046 21.1046 23 20 23ZM4 3V21H20V3H4ZM12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Tablet"
);
